import { Component } from '@angular/core';

@Component({
    selector: 'app-delete-product',
    templateUrl: './delete-product.component.html',
    styleUrls: ['./delete-product.component.css']
})
/** Delete-Product component*/
export class DeleteProductComponent {
    /** Delete-Product ctor */
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./src/app/product-components/delete-product/delete-product.component.ts